import "jquery-slimscroll";


export default {
    init: function ( $element ) {
        "use strict";
        var _this = this;

        _this.$rightNavbar = $element.find( '.navbar-right' );

        return _this;
    },

    activate: function () {
        "use strict";
        var _this = this;

        _this.$rightNavbar
            .find( '.dropdown-menu .body .menu' )
            .slimscroll( {
                height: '254px',
                color: 'rgba(0,0,0,0.5)',
                size: '4px',
                alwaysVisible: false,
                borderRadius: '0',
                railBorderRadius: '0'
            } );
    }
};
